__turbopack_context__.v({
  "band": "hero-sparkles-module__FqgfKa__band",
  "bandCore": "hero-sparkles-module__FqgfKa__bandCore",
  "glowNarrow": "hero-sparkles-module__FqgfKa__glowNarrow",
  "glowWide": "hero-sparkles-module__FqgfKa__glowWide",
  "head": "hero-sparkles-module__FqgfKa__head",
  "hero": "hero-sparkles-module__FqgfKa__hero",
  "lineNarrow": "hero-sparkles-module__FqgfKa__lineNarrow",
  "lineWide": "hero-sparkles-module__FqgfKa__lineWide",
  "meteors": "hero-sparkles-module__FqgfKa__meteors",
  "outcomesLine": "hero-sparkles-module__FqgfKa__outcomesLine",
  "outcomesTitle": "hero-sparkles-module__FqgfKa__outcomesTitle",
  "subhead": "hero-sparkles-module__FqgfKa__subhead",
});
